import React, { useEffect } from 'react'
import {
    AllEvents,
    createEditionViewItemListEvent,
} from '@news-mono/web-common'
import {
    StyledEditionsPage,
    StyledEditionsSection,
    StyledEditionsHeading,
    StyledOnEditionList,
} from './PreviousSpecialEditions.styled'
import { EditionV4DTO } from '@west-australian-newspapers/publication-types'
import { SpecialEditionItem } from './components/EditionItem'

export interface NightlyPreviousSpecialEditionsProps {
    title?: string
    editions: EditionV4DTO[]
    onEvent: (event: AllEvents) => void
}

export const NightlyPreviousSpecialEditionsV2: React.FC<NightlyPreviousSpecialEditionsProps> =
    ({ editions, title = 'Latest Nightly On Editions', onEvent }) => {
        useEffect(() => {
            const event = createEditionViewItemListEvent({
                editions: editions,
                collectionName: 'thenightly_on_home_page',
                itemCategory: 'latest_nightly_on_editions_page', // before change, will need to add to valid type first
            })
            event && onEvent(event)
        }, [editions, onEvent])

        return (
            <StyledEditionsPage>
                <StyledEditionsSection>
                    <StyledEditionsHeading>
                        {editions.length > 0 && <h2>{title}</h2>}
                    </StyledEditionsHeading>

                    <StyledOnEditionList>
                        {editions.map((edition, idx) => (
                            <SpecialEditionItem
                                key={idx}
                                edition={{
                                    title: edition.title,
                                    heading: edition.title,
                                    teaser: edition.teaser,
                                    publicationDate: edition.publicationDate,
                                    link: edition.editionWebUrl,
                                    imageURL:
                                        edition.mainImages?.[0]?.src || '',
                                    path: edition.primaryTopic ?? '',
                                    lazyloadImages: true, // Assuming lazyloadImages is not used here
                                    id: edition.id,
                                }}
                                onEvent={onEvent}
                            />
                        ))}
                    </StyledOnEditionList>
                </StyledEditionsSection>
            </StyledEditionsPage>
        )
    }
